/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 

// var toBold = document.getElementsByClassName('product-form__selected-value');
// for (var i=0; i<toBold.length; ++i) {
//   boldSecondWord(toBold[i]);
// }

// function boldSecondWord(elem) {
//   elem.innerHTML = elem.textContent.replace(/\w+ (\w+)/, function(s, c) {
//     return s.replace(c, '<span style="display: none;">'+c+'</span>');
//   });
// }


// Get the header element
const header = document.querySelector('#shopify-section-header');

// Get the initial offset position of the header
const headerOffset = header.offsetTop;

// Variable to store the previous scroll position
let prevScrollPosition = window.scrollY || document.documentElement.scrollTop;

// Add a scroll event listener to the window
window.addEventListener('scroll', () => {
  // Get the current scroll position
  const scrollPosition = window.scrollY || document.documentElement.scrollTop;

  // Check if the user is scrolling up and has scrolled at least 43 pixels
  if (scrollPosition < prevScrollPosition && scrollPosition <= 43) {
    // Remove the 'sticky' class from the header element
    header.classList.remove('sticky');
  }
  // Check if the user is scrolling down and has scrolled at least 147 pixels
  else if (scrollPosition > prevScrollPosition && scrollPosition >= 147) {
    // Add the 'sticky' class to the header element
    header.classList.add('sticky');
  }

  // Update the previous scroll position
  prevScrollPosition = scrollPosition;
});








// // Get the header element
// const header = document.querySelector('#shopify-section-header');

// // Get the initial offset position of the header
// const headerOffset = header.offsetTop;

// // Variable to store the previous scroll position
// let prevScrollPosition = window.pageYOffset;

// // Add a scroll event listener to the window
// window.addEventListener('scroll', () => {
//   // Get the current scroll position
//   const scrollPosition = window.pageYOffset;

//   // Check if the user is scrolling up and has scrolled at least 43 pixels
//   if (scrollPosition < prevScrollPosition && scrollPosition <= 43) {
//     // Remove the 'sticky' class from the header element
//     header.classList.remove('sticky');
//   }
//   // Check if the user is scrolling down and has scrolled at least 147 pixels
//   else if (scrollPosition > prevScrollPosition && scrollPosition >= 147) {
//     // Add the 'sticky' class to the header element
//     header.classList.add('sticky');
//   }

//   // Update the previous scroll position
//   prevScrollPosition = scrollPosition;
// });

const firstHeader = document.querySelector('.first_header');
let lastScrollPosition = 0;

window.addEventListener('scroll', () => {
  const currentScrollPosition = window.scrollY;

  if (currentScrollPosition <= 43) {
    firstHeader.classList.add('fade-in');
  } else if (currentScrollPosition < lastScrollPosition) {
    firstHeader.classList.add('fade-in');
  }

  lastScrollPosition = currentScrollPosition;
});

window.addEventListener('load', () => {
  firstHeader.classList.remove('fade-in');
});

    document.addEventListener("DOMContentLoaded", function() {
    // Function to check if we're on the cart page
    function isCartPage() {
        return window.location.pathname.includes('/cart');
    }

    if (isCartPage()) {
        // Function to show the preloader
        function showPreloader() {
            var preloader = document.getElementById("preloader");
            if (preloader) { // Check if the preloader element exists
                preloader.style.display = "flex";
                setTimeout(function() {
                    preloader.style.display = "none";
                }, 3000); // Adjust preloader display time if needed
            }
        }

        // Function to reset the preloader flag when leaving the cart page
        function resetCartPreloader() {
            if (!isCartPage()) {
                sessionStorage.removeItem("cartPreloaderShown");
            }
        }

        // Initial check when the page is loaded
        showPreloader();

        // Detect clicks and navigation changes (back/forward button)
        document.addEventListener('click', function() {
            setTimeout(function() {
                resetCartPreloader();
            }, 50);
        });

        // Detect browser navigation (back/forward)
        window.addEventListener('popstate', function() {
            resetCartPreloader();
        });
    }
});

// variant-carousel drag scroll
(function () {
  var carousel = document.getElementById('variant-carousel');
  if (!carousel) return;

  var isDragging = false;
  var startX, scrollLeft;

  carousel.addEventListener('mousedown', function (e) {
    isDragging = true;
    startX = e.pageX - this.offsetLeft;
    scrollLeft = this.scrollLeft;
  });

  carousel.addEventListener('mouseleave', function () { isDragging = false; });
  carousel.addEventListener('mouseup',    function () { isDragging = false; });

  carousel.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var x = e.pageX - this.offsetLeft;
    this.scrollLeft = scrollLeft - (x - startX) * 0.7;
  });
})();

// scroll carousel to selected variant
(function scrollToSelectedItem() {
  var carousel = document.getElementById('variant-carousel');
  if (!carousel) return;

  var selected = carousel.querySelector('.variant-swatch__radio:checked');
  if (!selected) return;

  var itemRect      = selected.parentElement.getBoundingClientRect();
  var containerRect = carousel.getBoundingClientRect();

  if (itemRect.left < containerRect.left || itemRect.right > containerRect.right) {
    carousel.scrollTo({
      left: itemRect.left - containerRect.left + carousel.scrollLeft,
      behavior: 'smooth'
    });
  }
})();

// RRP tooltip — body-teleport approach
(function () {
  var globalTip = document.createElement('div');
  globalTip.id = 'rrp-global-tooltip';
  document.body.appendChild(globalTip);

  var activeRrp = null;

  function hideTooltip() {
    globalTip.style.display = 'none';
    if (activeRrp) { activeRrp.classList.remove('tooltip-open'); activeRrp = null; }
  }

  function positionTooltip(trigger) {
    var rect = trigger.getBoundingClientRect();
    var tipW = Math.min(window.innerWidth * 0.7, 220);
    var tipH = globalTip.offsetHeight || 100;
    var centerX = rect.left + rect.width / 2;
    var left = Math.max(tipW / 2 + 8, Math.min(centerX, window.innerWidth - tipW / 2 - 8));
    var top = rect.bottom + 8;
    if (top + tipH + 12 > window.innerHeight) top = rect.top - tipH - 8;
    globalTip.style.left = (left - tipW / 2) + 'px';
    globalTip.style.top = top + 'px';
  }

  window.addEventListener('scroll', hideTooltip, { passive: true });

  function showTooltip(rrp) {
    var trigger = rrp.querySelector('.rrp-trigger') || rrp;
    var sourceTooltip = rrp.querySelector('.tooltip');
    if (!sourceTooltip) return;
    hideTooltip();
    globalTip.innerHTML = sourceTooltip.innerHTML;
    globalTip.style.display = 'block';
    positionTooltip(trigger);
    activeRrp = rrp;
    rrp.classList.add('tooltip-open');
  }

  var isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (isDesktop) {
    document.addEventListener('mouseover', function (e) {
      var rrp = e.target.closest('.rrp');
      if (!rrp || activeRrp === rrp) return;
      showTooltip(rrp);
    });

    document.addEventListener('mouseout', function (e) {
      var rrp = e.target.closest('.rrp');
      if (!rrp) return;
      var rel = e.relatedTarget;
      if (rel && (rrp.contains(rel) || rel === globalTip || globalTip.contains(rel))) return;
      hideTooltip();
    });

    globalTip.addEventListener('mouseout', function (e) {
      var rel = e.relatedTarget;
      if (rel && rel.closest('.rrp')) return;
      hideTooltip();
    });
  } else {
    document.addEventListener('click', function (e) {
      var rrp = e.target.closest('.rrp');
      if (!rrp) { hideTooltip(); return; }
      if (activeRrp === rrp) { hideTooltip(); return; }
      showTooltip(rrp);
    });
  }
})();

// Omnibus + RRP — atnaujina kai keičiasi variantas
document.addEventListener('variant:changed', function (e) {
  var variant = e.detail && e.detail.variant;
  if (!variant) return;

  var currencyFormat = window.theme
    ? (window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat)
    : '{{amount_with_comma_separator}} €';

  function formatMoney(cents) {
    var fmt = currencyFormat || '{{amount_with_comma_separator}} €';
    var num = (cents / 100).toFixed(2);
    var parts = num.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    var dec = parts[1] ? ',' + parts[1] : '';
    var amount = whole + dec;
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  var rrp = (window.__omnibusRrp || {})[variant.id];
  var lowest = (window.__omnibusLowest || {})[variant.id];
  if (lowest === undefined) lowest = variant.price;

  var priceEl = document.querySelector('.main-price .price-value');
  if (priceEl) priceEl.textContent = formatMoney(variant.price);

  var rrpBlock = document.querySelector('.js-rrp-block');
  if (rrpBlock) {
    if (rrp && variant.price < rrp) {
      rrpBlock.style.display = '';
      var rrpVal = rrpBlock.querySelector('.rrp-value');
      if (rrpVal) rrpVal.textContent = formatMoney(rrp);
    } else {
      rrpBlock.style.display = 'none';
    }
  }

  var lowestEl = document.querySelector('.lowest-price-value');
  if (lowestEl) {
    lowestEl.textContent = formatMoney(lowest);
    lowestEl.dataset.variantId = variant.id;
  }
});

// Push out-of-stock product items to end of any product grid
(function () {
  function reorderOos(list) {
    if (!list) return;
    const items = Array.from(list.children);
    const oos = items.filter(el => el.dataset.available === 'false' || el.dataset.available === '');
    if (!oos.length) return;
    oos.forEach(el => list.appendChild(el));
  }

  function runAll() {
    document.querySelectorAll('.product-list').forEach(reorderOos);
  }

  document.addEventListener('DOMContentLoaded', runAll);
  document.addEventListener('theme:loading:end', function () {
    setTimeout(runAll, 50);
  });
})();
